import { Button } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";
import TextInput from "components/forms/TextInput";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { useBackendError } from "services/hooks";
import { reset } from "services/user";

const Reset = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const { handleRequestError } = useBackendError();
  const { enqueueSnackbar } = useSnackbar();
  const { token } = useParams<{ token:string }>();
  const history = useHistory();

  const handleResetPassword = async (form) => {
    try {
      await reset(token,form.password);
      enqueueSnackbar("Your password has been reset! You can now login", {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
      handleClose();
    } catch(err) {
      handleRequestError(err);
    }
  }

  const handleClose = () => {
    history.push('/')
  }

  return (
    <DialogWrapper
      title="Create New Password"
      isOpen={true}
      onClose={handleClose}
      onDialogClose={handleClose}
      footer={false}
    >
      <>
        <form onSubmit={handleSubmit(handleResetPassword)}>
          <TextInput
            control={control}
            name="password" 
            label="Password"
            errors={errors}
            type="password"
            rules={{
              required: "This field is required",
              minLength: {
                value: 5,
                message: "Password must have at least 5 characters.",
              },
            }}
          />
          <TextInput
            control={control}
            name="confirm_password" 
            label="Confirm Password"
            errors={errors}
            type="password"
            rules={{
              validate: (value) => {
                return (
                  value === watch("password") || "Your passwords must match."
                );
              },
            }}
          />
          <div className="d-flex justify-content-end">
            <Button 
              variant="outlined" 
              size="small" 
              className="me-3" 
              onClick={handleClose}>
                Cancel
            </Button>
            <Button type="submit" variant="contained" size="small">Submit</Button>
          </div>
        </form>
      </>
    </DialogWrapper>
  );
};

export default Reset;
